import Api from '../Api';

export const getProducts = () => async dispatch => {
  const { data } = await Api.get('/products');
  dispatch({
    type: 'FETCH_PRODUCTS',
    payload: data,
  });
};

export const clearProducts = () => {
  return {
    type: 'CLEAR_PRODUCTS',
  };
};

export const getProduct = id => async dispatch => {
  const { data } = await Api.get(`/products/${id}`);
  dispatch({
    type: 'FETCH_PRODUCT',
    payload: data,
  });
};

export const clearProduct = () => {
  return {
    type: 'CLEAR_PRODUCT',
  };
};

export const getProductIds = customerId => async dispatch => {
  const { data } = await Api.get('/products/ids', { customerId });
  dispatch({
    type: 'FETCH_PRODUCT_IDS',
    payload: data,
  });
};

export const clearProductIds = () => {
  return {
    type: 'CLEAR_PRODUCT_IDS',
  };
};
